import { render } from "./ChoosePaymentType.vue?vue&type=template&id=347a7c65&scoped=true"
import script from "./ChoosePaymentType.vue?vue&type=script&lang=js"
export * from "./ChoosePaymentType.vue?vue&type=script&lang=js"

import "./ChoosePaymentType.vue?vue&type=style&index=0&id=347a7c65&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347a7c65"]])

export default __exports__